import React, { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { FileEntityType } from '../../../types/file';
import { User } from '../../../types/user';
import { FileViewLoader } from '../../../VentoryUI/components/common/File';

interface ProfileAvatarProps {
  size: Size;
  onClick?: () => void;
  user?: User;
}

const sizes = {
  sm: 'h-8 w-8 text-sm',
  md: 'h-16 w-16 text-base',
  lg: 'h-24 w-24 text-[48px]',
} as const;

type Size = keyof typeof sizes;

export default function ProfileAvatar({ size = 'sm', onClick, user }: ProfileAvatarProps) {
  const { currentUser } = useContext(UserContext);
  user ||= currentUser || undefined;
  if (!user) return null;

  const className = `rounded-full ${sizes[size]} overflow-hidden rounded-full`;

  const wrap = (node: React.ReactNode) => {
    if (onClick)
      return (
        <button className={className} onClick={onClick}>
          {node}
        </button>
      );
    else return <div className={className}>{node}</div>;
  };

  return wrap(
    user.profilePicture && !user.profilePicture.endsWith('ventory/Profile.svg') ? (
      <FileViewLoader
        className='object-fill'
        fileId={user.profilePicture}
        fileEntityType={FileEntityType.user}
        fallback={<FallbackProfileAvatar user={user} />}
      />
    ) : (
      <FallbackProfileAvatar user={user} />
    ),
  );
}

interface FalbackProfileAvatarProps {
  user: User;
}

function FallbackProfileAvatar({ user }: FalbackProfileAvatarProps) {
  return (
    <div className='flex h-full w-full items-center justify-center rounded-full bg-primary text-on-primary'>
      <p>
        {user.firstName[0]}
        {user.lastName[0]}
      </p>
    </div>
  );
}
